var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco16MenuSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7c0-3.866-3.134-7-7-7S0 3.134 0 7s3.134 7 7 7 7-3.134 7-7z",
    transform: "translate(-520 -49) translate(520 49) translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.683 8.562C10.887 8.082 11 7.554 11 7c0-2.209-1.79-4-4-4-.554 0-1.082.113-1.562.317l2.123 2.122c.283.284.44.66.44 1.061 0 .401-.157.777-.44 1.061C7.277 7.844 6.9 8 6.5 8c-.401 0-.778-.156-1.061-.44L3.317 5.439C3.113 5.918 3 6.446 3 7c0 2.209 1.79 4 4 4 .554 0 1.082-.113 1.562-.317l2.209 2.209c.85-.546 1.575-1.27 2.12-2.121l-2.208-2.209z",
    transform: "translate(-520 -49) translate(520 49) translate(1 1)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16MenuSetting);
export default __webpack_public_path__ + "static/media/ico16MenuSetting.5edd5936.svg";
export { ForwardRef as ReactComponent };